import React from "react"
import UserIcon from "@atlaskit/icon/glyph/user-avatar-circle"
import QuizListIcon from "@atlaskit/icon/glyph/editor/bullet-list"
import DashboardIcon from "@atlaskit/icon/glyph/dashboard"
import PersonIcon from "@atlaskit/icon/glyph/person"
import PeopleGroupIcon from "@atlaskit/icon/glyph/people-group"
import WorldIcon from "@atlaskit/icon/glyph/world"
import QuestionCircleIcon from "@atlaskit/icon/glyph/question-circle"
import EditorBulletListIcon from '@atlaskit/icon/glyph/editor/bullet-list';
import LinkIcon from '@atlaskit/icon/glyph/link';

export default {
  quizLists: <QuizListIcon label={""} />,
  users: <UserIcon label={""} />,
  dashboard: <DashboardIcon label={""} />,
  person: <PersonIcon label={""} />,
  peopleGroup: <PeopleGroupIcon label={""} />,
  world: <WorldIcon label={""} />,
  qa: <QuestionCircleIcon label={""} />,
  list: <EditorBulletListIcon size='large' label={""} />,
  hook: <LinkIcon size='' label={""} />,
}



// WEBPACK FOOTER //
// ./src/themes/icon.js